export default {"src":"/_next/static/media/equipment.8edd6a2e.svg","height":121,"width":121};